import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['statusSelect', 'labDateField', 'labDateLabel', 'labDateHint']

  connect () {
    this.#toggle()
  }

  change () {
    this.#toggle()
  }

  #toggle () {
    this.#applyRequired(
      this.statusSelectTarget.value === 'D',
      this.labDateFieldTarget,
      this.labDateLabelTarget,
      this.labDateHintTarget,
      'Lab Date'
    )
  }

  #applyRequired (required, field, label, hint, labelText) {
    field.required = required
    hint.classList.toggle('hidden', !required)
    label.innerHTML = required
      ? `${labelText} <span class="text-red-500">*</span>`
      : labelText
  }
}
